import { z } from 'zod';
import { addressSchema, idSchema, isoDateTime, pageQuerySchema, paginated } from './common.js';
/* -------------------------------- Client -------------------------------- */
export const clientSchema = z.object({
    id: idSchema,
    code: z.string().trim().toUpperCase().min(2).max(32),
    name: z.string().min(1).max(200),
    contactEmail: z.string().trim().toLowerCase().email().nullish(),
    phone: z.string().trim().max(40).nullish(),
    address: addressSchema.nullish(),
    paymentTermsDays: z.number().int().min(0).max(365).default(30),
    active: z.boolean().default(true),
    notes: z.string().max(2000).nullish(),
    createdAt: isoDateTime,
    updatedAt: isoDateTime,
});
export const clientCreateSchema = z.object({
    code: z.string().trim().min(2).max(32),
    name: z.string().trim().min(1).max(200),
    contactEmail: z.string().trim().toLowerCase().email().nullish(),
    phone: z.string().trim().max(40).nullish(),
    address: addressSchema.nullish(),
    paymentTermsDays: z.number().int().min(0).max(365).default(30),
    active: z.boolean().default(true),
    notes: z.string().max(2000).nullish(),
});
export const clientUpdateSchema = clientCreateSchema.partial().refine((v) => Object.keys(v).length > 0, { message: 'No fields to update' });
export const clientListSchema = paginated(clientSchema);
export const clientListQuerySchema = pageQuerySchema.extend({
    active: z.coerce.boolean().optional(),
    search: z.string().max(200).optional(),
});
/* --------------------------------- Zone --------------------------------- */
export const zoneSchema = z.object({
    id: idSchema,
    code: z.string().trim().toUpperCase().min(2).max(32),
    name: z.string().min(1).max(120),
    description: z.string().max(1000).nullish(),
    active: z.boolean().default(true),
    createdAt: isoDateTime,
    updatedAt: isoDateTime,
});
export const zoneCreateSchema = z.object({
    code: z.string().trim().min(2).max(32),
    name: z.string().trim().min(1).max(120),
    description: z.string().max(1000).nullish(),
    active: z.boolean().default(true),
});
/* -------------------------------- Route --------------------------------- */
export const routeSchema = z.object({
    id: idSchema,
    code: z.string().trim().toUpperCase().min(2).max(32),
    name: z.string().min(1).max(160),
    originZoneId: idSchema.nullish(),
    destinationZoneId: idSchema.nullish(),
    distanceKm: z.number().finite().positive().nullish(),
    durationMin: z.number().finite().positive().nullish(),
    active: z.boolean().default(true),
    createdAt: isoDateTime,
    updatedAt: isoDateTime,
});
export const routeCreateSchema = z.object({
    code: z.string().trim().min(2).max(32),
    name: z.string().trim().min(1).max(160),
    originZoneId: idSchema.nullish(),
    destinationZoneId: idSchema.nullish(),
    distanceKm: z.number().finite().positive().nullish(),
    durationMin: z.number().finite().positive().nullish(),
    active: z.boolean().default(true),
});
//# sourceMappingURL=location.js.map